var _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconFacebook(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icon_-_Facebook",
    "data-name": "Icon - Facebook",
    xmlns: "http://www.w3.org/2000/svg",
    width: 30.478,
    height: 30.478,
    viewBox: "0 0 30.478 30.478",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-facebook-f",
    "data-name": "Icon awesome-facebook-f",
    d: "M11.39,10.338l.543-3.326H8.539V4.853c0-.91.474-1.8,1.994-1.8h1.543V.225A19.969,19.969,0,0,0,9.337,0C6.542,0,4.716,1.593,4.716,4.477V7.012H1.609v3.326H4.716v8.04H8.539v-8.04Z",
    transform: "translate(8.938 5.752)",
    fill: "#303030"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Elipse_17",
    "data-name": "Elipse 17",
    fill: "none",
    stroke: "#303030",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 15.239,
    cy: 15.239,
    r: 15.239,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15.239,
    cy: 15.239,
    r: 14.739,
    fill: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFacebook);
export default __webpack_public_path__ + "static/media/icon-facebook.b006f56836081568e4fd22e926138fda.svg";
export { ForwardRef as ReactComponent };